import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const steps = [
  { titleKey: 'process_1_title', descKey: 'process_1_desc', icon: 'ri-calendar-check-line', number: '1' },
  { titleKey: 'process_2_title', descKey: 'process_2_desc', icon: 'ri-calendar-event-line', number: '2' },
  { titleKey: 'process_3_title', descKey: 'process_3_desc', icon: 'ri-search-line', number: '3' },
  { titleKey: 'process_4_title', descKey: 'process_4_desc', icon: 'ri-mail-send-line', number: '4' },
];

export default function ProcessInspection() {
  const { t } = useTranslation('inspection');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="process" className="bg-white py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div
          className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="font-manrope font-bold text-slate-primary text-2xl md:text-3xl lg:text-4xl">
            {t('process_h2')}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {steps.map((step, idx) => (
            <div
              key={idx}
              className={`relative text-center transition-all duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${idx * 150 + 200}ms` }}
            >
              {/* Connector line for desktop */}
              {idx < steps.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-[60%] w-[80%] h-0.5 bg-copper/20" />
              )}

              <div className="w-16 h-16 flex items-center justify-center rounded-full bg-copper text-white font-manrope font-bold text-xl mx-auto mb-4 relative z-10">
                {step.number}
              </div>
              <h3 className="font-manrope font-bold text-slate-primary text-sm md:text-base mb-2">
                {t(step.titleKey)}
              </h3>
              <p className="text-slate-primary/60 text-sm leading-relaxed">
                {t(step.descKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}